import React from 'react';
import {OverlayTrigger, Tooltip as BSTooltip} from 'react-bootstrap';

export function Tooltip(props) {
  return(<OverlayTrigger placement="bottom" container={props.container} overlay={<BSTooltip id={props.titulo}>{props.titulo}</BSTooltip>}>
           {props.children}
         </OverlayTrigger>);
  }
